import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import zIndex from '@material-ui/core/styles/zIndex';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';

const useStyles = makeStyles(theme => {
  const { marginLR, paddingLR } = theme.mixins;
  return {
    listingLayoutWrappeer: {
      paddingTop: pxToRem(48),
      paddingBottom: pxToRem(40),
      ...paddingLR(theme.spacing(3), theme.spacing(3)),
      // background: theme.mixins.milkWhite(200),
      background: theme.mixins.White(),
      minHeight: '60vh',
      flexDirection: 'column',
      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        padding: `${theme.spacing(11)} 5.5%`,
        margin: 0,
      },
      '& .slider': {
        overflow: 'hidden',
        borderRadius: pxToRem(10),
        ...theme.mixins.paddingRight(`${24}px !important`),
        '[dir="rtl"] &': {
          paddingRight: 0,
        },
        [theme.breakpoints.down('md')]: {
          padding: '0 !important',
          marginBottom: `${pxToRem(24)} !important`,
        },
        '& .heartIcon': {
          [theme.breakpoints.down('sm')]: {
            marginTop: pxToRem(16)
          },
          '& svg': {
            width: pxToRem(24),
            height: pxToRem(24)
          },
        },
        '& .imageWrap': {
          height: pxToRem(224),
          borderTopLeftRadius: pxToRem(10),
          borderTopRightRadius: pxToRem(10),
          [theme.breakpoints.down('sm')]: {
            height: pxToRem(146),
          },
          overflow: 'hidden',
          '& .tagWrapper': {
            '& span': {
              '[dir="rtl"] &': {
                fontSize: pxToRem(12),
                lineHeight: pxToRem(16)
              },
            },
            [theme.breakpoints.down('sm')]: {
              ...theme.mixins.left(16)
            },
          },
          '& .img-to-animate-wrapper': {
            transition: 'all 1s ease',
            '& img': {
              transition: 'ease 0.5s all',
            }
          }
        },
        '& .calenderType': {
          [theme.breakpoints.down('sm')]: {
            ...theme.mixins.paddingLeft(0)
          },
          '& .eventTitle': {
            fontSize: pxToRem(22),
            lineHeight: pxToRem(32),
            [theme.breakpoints.down('sm')]: {
              margin: `${pxToRem(4)} 0`,
              fontSize: pxToRem(16),
              lineHeight: pxToRem(24)
            },
          },
          '& .eventName': {
            color: '#000',
            [theme.breakpoints.down('sm')]: {
              fontSize: pxToRem(12),
              lineHeight: pxToRem(16)
            }
          },
          '& .eventLocation': {
            color: '#706C6C',
            fontFamily: theme.custom.fontFamily.primaryRegular,
            [theme.breakpoints.down('sm')]: {
              fontSize: pxToRem(12),
              lineHeight: pxToRem(16)
            }
          }
        }
      },
      '& .filterWrap': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          overflow: 'scroll',
          paddingBottom: pxToRem(16)
        },
        '& .dateFilters': {
          display: 'flex',
          alignItems: 'center',
          gap: pxToRem(8),
          [theme.breakpoints.down('md')]: {
            ...theme.mixins.paddingRight(65)
          },
          '& .react-datepicker-wrapper': {
            height: pxToRem(40),
            '& .react-datepicker__input-container': {
              height: '100%',
              '& input': {
                height: '100%',
                width: '40px',
                borderRadius: '20px',
                border: '1px solid #E9E9E9'
              }
            }
          },
          '& .react-datepicker-popper': {
            zIndex: 999,
            '& .react-datepicker': {
              borderRadius: borderRadius.b0,
              border: 'none',
              boxShadow: theme.shadows[1],
              width: '100%',
              display: 'flex',

              '& .react-datepicker__navigation': {
                border: 'solid',
                borderWidth: '0 2px 2px 0',
              },
              '& .react-datepicker__navigation--previous': {
                transform: 'rotate(138deg)',
                top: pxToRem(19),
                left: pxToRem(29),
                '[dir="rtl"] &': {
                  right: pxToRem(29),
                  left: 'inherit',
                  transform: 'rotate(314deg)',
                },
              },
              '& .react-datepicker__navigation--next': {
                transform: 'rotate(314deg)',
                top: pxToRem(19),
                right: pxToRem(29),
                '[dir="rtl"] &': {
                  left: pxToRem(29),
                  right: 'inherit',
                  transform: 'rotate(138deg)',
                },
              },
              '& .react-datepicker__triangle': {
                display: 'none',
              },
              '& .react-datepicker__month-container': {
                width: pxToRem(282),
                '& .react-datepicker__day-names, .react-datepicker__week': {
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '5px',
                },
                '& .react-datepicker__month': {
                  ...theme.typography.labelRegular,
                  background: `${theme.mixins.White()} !important`,

                  '& .react-datepicker__day--selecting-range-end, .react-datepicker__day--range-end, .react-datepicker__day--range-start': {
                    background: theme.mixins.Black(),
                    borderRadius: `${borderRadius.circle}`,
                    color: theme.mixins.White(),
                  },
                  '& .react-datepicker__day--in-selecting-range': {
                    background: theme.palette.action.disabledBackground,
                    color: theme.mixins.Black(),
                    borderRadius: `${borderRadius.b0}`,
                    position: 'relative',
                    '&:after': {
                      content: `''`,
                      width: '5px',
                      height: '100%',
                      top: '0',
                      ...theme.mixins.left('100%'),
                      position: 'absolute',
                      background: theme.palette.action.disabledBackground,
                    },
                    '&.react-datepicker__day--selecting-range-start': {
                      background: theme.mixins.Grey(),
                      borderRadius: `${borderRadius.circle}`,
                      color: theme.mixins.White(),
                    },
                    '&.react-datepicker__day--selecting-range-end': {
                      background: theme.mixins.Black(),
                      borderRadius: `${borderRadius.circle}`,
                      color: theme.mixins.White(),
                    },
                  },
                  '& .react-datepicker__day--in-range': {
                    background: theme.palette.action.disabledBackground,
                    color: theme.mixins.Black(),
                    borderRadius: `${borderRadius.b0}`,
                    position: 'relative',
                    '&:after': {
                      content: `''`,
                      width: '5px',
                      height: '100%',
                      top: '0',
                      ...theme.mixins.left('100%'),
                      position: 'absolute',
                      background: theme.palette.action.disabledBackground,
                    },
                    '&.react-datepicker__day--range-start': {
                      background: theme.mixins.Black(),
                      borderRadius: `${borderRadius.circle}`,
                      color: theme.mixins.White(),
                    },
                    '&.react-datepicker__day--range-end': {
                      background: theme.mixins.Black(),
                      borderRadius: `${borderRadius.circle}`,
                      color: theme.mixins.White(),
                    },
                    '&.react-datepicker__day--selecting-range-start': {
                      // background: theme.mixins.Grey(),
                      borderRadius: `${borderRadius.circle}`,
                      color: theme.mixins.White(),
                    },
                  },
                  '& .react-datepicker__day': {
                    height: pxToRem(32),
                    width: pxToRem(32),
                    // borderRadius: borderRadius.circle,
                    paddingTop: 6,
                    paddingBottom: 6,
                    margin: '3px 0px 3px 0px',
                    lineHeight: pxToRem(22),

                    '&:hover': {
                      borderRadius: borderRadius.circle,
                    },

                    '&.react-datepicker__day--keyboard-selected': {
                      color: theme.mixins.Black(),
                      '&:not(.react-datepicker__day--in-selecting-range)': {
                        backgroundColor: theme.mixins.White(),
                      },

                      '&.react-datepicker__day--range-end, &.react-datepicker__day--range-start': {
                        background: theme.mixins.Black(),
                        borderRadius: `${borderRadius.circle}`,
                        color: theme.mixins.White(),
                      },
                    },
                  },
                  '& .react-datepicker__day--today': {

                    '&:hover': {
                      backgroundColor: theme.mixins.Grey(200),
                      color: theme.mixins.Black(),
                      border: '0px'
                    },
                    '&.react-datepicker__day--range-end, &.react-datepicker__day--range-start': {
                      background: theme.mixins.Grey(),
                      borderRadius: `${borderRadius.circle} !important`,
                      color: theme.mixins.White(),
                    },
                  },
                  '& .react-datepicker__day--selected': {
                    background: theme.mixins.Grey(),
                    color: theme.mixins.White(),
                    borderRadius: '50%',
                  },
                  '& .react-datepicker__day--outside-month, & .react-datepicker__day--outside-month.react-datepicker__day--range-end': {
                    backgroundColor: `${theme.mixins.White()} !important`,
                    borderRadius: '0',
                    color: `${theme.palette.action.disabled} !important`,
                    pointerEvents: 'none',
                    position: 'relative',
                    '&:after': {
                      backgroundColor: `${theme.mixins.White()} !important`,
                    },
                  },
                },
                '& .react-datepicker__header': {
                  background: theme.mixins.White(),
                  borderBottom: 'none',

                  '& .react-datepicker__day-names .react-datepicker__day-name': {
                    ...theme.typography.labelRegular,
                    color: theme.palette.text.datePicker,
                    marginTop: pxToRem(10),
                    margin: 4,
                  },
                  '& .react-datepicker__current-month': {
                    ...theme.typography.body2,
                    marginTop: 5,
                  },
                },
                '& .react-datepicker__day-name, .react-datepicker__day': {
                  margin: '0.4rem',
                },
              },
            },
          },
          '& .calendarIcon': {
            position: 'absolute',
            width: pxToRem(16),
            height: pxToRem(16),
            top: pxToRem(16),
            ...theme.mixins.right(pxToRem(20)),
          },

          // fix bgcolor hover issues.
          '& .react-datepicker__day, .react-datepicker__month-text, .react-datepicker__quarter-text': {
            '&:not(.react-datepicker__day--disabled):hover': {
              background: theme.mixins.Grey() + ' !important',
              color: theme.mixins.White(),
            },
          },
          '& .date-selected .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__day--selecting-range-start)': {
            background: theme.mixins.White(),
            '&:after': {
              display: 'none',
            },
          },
          '& .date-selected .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range):after': {
            display: 'none',
          },
        },
        '& .filtersInner': {
          [theme.breakpoints.down('md')]: {
            position: 'absolute',
            width: pxToRem(69),
            background: 'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 32.26%)',
            // right: 0,
            ...theme.mixins.right(0),
            top: 0,
            display: 'flex',
            justifyContent: 'flex-end',
            '[dir="rtl"] &': {
              background: 'linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #fff 32.26%)',
            },
          },
        }
      },
      '& .stickyCta': {
        backgroundColor: '#FCEFDE',
        left: 0,
        width: '100%',
        padding: `${pxToRem(12)} ${pxToRem(24)}`,
        '& .mobileStickyWrapper': {
          display: 'flex',
          gap: pxToRem(16),
        }
      }
    },
    filterSection: {
      [theme.breakpoints.up('lg')]: {
        flexBasis: '25%',
        position: 'relative',
        zIndex: 1,
      },
      [theme.breakpoints.down('lg')]: {
        '& section': {
          transform: 'none',
        },
      },
    },
    smartList: {
      [theme.breakpoints.up('lg')]: {
        flexBasis: '75%',
        ...marginLR(pxToRem(24), 0),
      },
      '& :last-child .smart-list-wrapper': {
        marginBottom: '0',
      },
    },
    filterdList: {
      overflowAnchor: 'none',
      '&.sty2': {
        width: 'calc(100% + 24px)',
        zIndex: 0,
        '& .noResultAlign': {
          display: 'none'
        },
        '& .OrangeCTA': {
          backgroundColor: '#FF8707',
          marginTop: pxToRem(-4),
          height: pxToRem(48),
          '& .MuiButton-label': {
            display: 'flex',
            flexDirection: 'row-reverse',

            '& svg': {
              ...theme.mixins.marginLeft(pxToRem(8)),
            },
          },
          '& .MuiButton-endIcon': {
            display: 'none'
          }
        },
        '& .ADnoResult': {
          textAlign: 'center',
          backgroundColor: '#F7F7F7',
          padding: `${pxToRem(40)} ${pxToRem(48)}`,
          [theme.breakpoints.down('md')]: {
            padding: `${pxToRem(32)} ${pxToRem(16)}`,
          },
          '& h1': {
            fontFamily: theme.custom.fontFamily.primaryBold,
            color: '#000000',
            [theme.breakpoints.down('md')]: {
              fontSize: pxToRem(20),
              lineHeight: pxToRem(32)
            },
          },
          '& a': {
            cursor: 'pointer',
            fontFamily: theme.custom.fontFamily.primaryBold,
            color: '#FF8707',
            textDecoration: 'underline',
            fontSize: pxToRem(16),
            lineHeight: pxToRem(24)
          },
          '& .para': {
            margin: '12px auto 16px',
            color: '#000000',
            [theme.breakpoints.down('md')]: {
              maxWidth: pxToRem(234),
              fontSize: pxToRem(14),
              lineHeight: pxToRem(24)
            },
          }
        },
        '& .ADCalenderGrid': {
          '[dir="rtl"] &': {
            paddingInlineStart: 0,
          },
          marginBottom: 0,
          [theme.breakpoints.down('md')]: {
            padding: '0 !important',
            margin: '0 !important',
          },
        },
        [theme.breakpoints.down('md')]: {
          width: '100%'
        },
      },
      [theme.breakpoints.up('lg')]: {
        flexBasis: '75%',
        // ...marginLR(pxToRem(24), 0),
      },
    }
  };
});

export default useStyles;
